import React from "react";
import styled from "styled-components";

const SpeakerCard = ({ imgSrc, speakerName, role, organization }) => {
  return (
    <SpeakerWrapper>
      <Img src={imgSrc} alt={`Picture of ${speakerName}`} />

      <SpeakerInfoCard>
        <Text>{speakerName}</Text>
        <Text
          style={{
            fontSize: "12px",
            color: "#a7a7a7",
          }}
        >
          {role}, {organization}
        </Text>
      </SpeakerInfoCard>
    </SpeakerWrapper>
  );
};

export default SpeakerCard;

const SpeakerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  margin-bottom:60px
`;

const Img = styled.img`
  padding: 4px;
  gap: 10px;
  width: 42px;
  height: 42px;
  border: 1px solid #2e6d7d;
  border-radius: 100%;
`;
const SpeakerInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Text = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  color: #4f4f4f;
  opacity: 0.9;
`;